if (!customElements.get('gcb-purchase-bar')) {
  customElements.define('gcb-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.gcb-product-pilot');
      this.form = document.getElementById(this.dataset.productForm);
      this.primary = this.form?.querySelector('[name="add"]');
      this.button = this.querySelector('button');
      this.price = this.querySelector('.gcb-purchase-bar__price');
      this.sourcePrice = this.section?.querySelector('.product-info__price');
      if (!this.form || !this.primary || !this.sourcePrice) return;
      this.visibility = new IntersectionObserver(entries => {
        this.hidden = entries[0].isIntersecting;
      }, { threshold: 0.25 });
      this.sync = () => {
        const primary = this.form.querySelector('[name="add"]');
        const source = this.section.querySelector('.product-info__price .price__current');
        if (!primary) return;
        if (this.observedPrimary !== primary) {
          this.visibility.disconnect();
          this.visibility.observe(primary);
          this.observedPrimary = primary;
        }
        const price = source?.textContent.trim();
        if (price && this.price.textContent !== price) this.price.textContent = price;
        const disabled = primary.disabled || primary.getAttribute('aria-disabled') === 'true';
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        const label = primary.textContent.trim();
        if (this.button.textContent !== label) this.button.textContent = label;
      };
      this.sync();
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.section, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true });
      this.onError = () => {
        const error = this.section.querySelector('.js-form-error');
        if (error && !error.hidden) {
          error.tabIndex = -1;
          error.scrollIntoView({ behavior: 'smooth', block: 'center' });
          error.focus({ preventScroll: true });
        }
      };
      this.section.addEventListener('on:cart:error', this.onError);
      this.hidden = false;
    }
    disconnectedCallback() {
      this.visibility?.disconnect();
      this.mutations?.disconnect();
      this.section?.removeEventListener('on:cart:error', this.onError);
    }
  });
}

if (!customElements.get('gcb-buy-now')) {
  customElements.define('gcb-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      this.primary = this.form?.querySelector('[name="add"]');
      if (!this.form || !this.button || !this.primary) return;
      this.label = this.button.textContent.trim();
      this.sync = () => {
        this.primary = this.form.querySelector('[name="add"]');
        const disabled = Boolean(this.busy || !this.primary || this.primary.disabled ||
          this.primary.getAttribute('aria-disabled') === 'true');
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
      };
      this.reset = () => {
        this.busy = false;
        this.button.textContent = this.label;
        this.button.removeAttribute('aria-busy');
        this.sync();
      };
      this.onSubmit = async event => {
        if (event.submitter !== this.button) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.button.disabled || !this.form.reportValidity()) return;
        const data = new FormData(this.form);
        const variantId = String(data.get('id') || '');
        const quantity = Number(data.get('quantity') || 1);
        if (!/^\d+$/.test(variantId) || !Number.isSafeInteger(quantity) || quantity < 1) return;
        const attributes = [];
        for (const [name, value] of data.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value) attributes.push({ key: match[1], value });
        }
        const input = { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity, attributes }] };
        if (this.dataset.country) input.buyerIdentity = { countryCode: this.dataset.country };
        this.busy = true;
        this.button.textContent = this.dataset.openingLabel;
        this.button.setAttribute('aria-busy', 'true');
        this.sync();
        const errorBox = this.form.querySelector('.js-form-error');
        if (errorBox) errorBox.hidden = true;
        try {
          const response = await fetch('/api/2026-07/graphql.json', {
            method: 'POST',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              query: "mutation GcbBuyNow($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity } userErrors { message } } }",
              variables: { input }
            })
          });
          const result = await response.json();
          const payload = result.data?.cartCreate;
          const userError = payload?.userErrors?.map(error => error.message).join(' ');
          if (!response.ok || result.errors?.length || userError || !payload?.cart?.checkoutUrl) {
            throw new Error(userError || this.dataset.errorLabel);
          }
          if (payload.cart.totalQuantity !== quantity) throw new Error(this.dataset.errorLabel);
          window.location.assign(payload.cart.checkoutUrl);
        } catch (error) {
          this.reset();
          if (errorBox) {
            errorBox.textContent = error instanceof TypeError ? this.dataset.errorLabel : error.message || this.dataset.errorLabel;
            errorBox.hidden = false;
            errorBox.tabIndex = -1;
            errorBox.focus();
          }
        }
      };
      this.form.addEventListener('submit', this.onSubmit, true);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.form, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true });
      window.addEventListener('pageshow', this.reset);
      this.reset();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.observer?.disconnect();
      window.removeEventListener('pageshow', this.reset);
    }
  });
}
